import { Channel } from '../../../api/channel/getChannel'
import { ChannelTypes } from '../channelType'

export const getBannerDisplayData = (
  channelDetails: Channel,
  channelType: ChannelTypes
) => {
  const subscriptionsAvailable =
    channelDetails &&
    channelDetails.type &&
    [ChannelTypes.club, ChannelTypes.team].includes(
      ChannelTypes[channelType]
    ) &&
    !channelDetails?.isRootChannel &&
    channelDetails?.meta_data.store.has_monthly_supporter

  const eventPassAvailable =
    channelDetails &&
    channelDetails.type &&
    ChannelTypes[channelType] === ChannelTypes.event &&
    channelDetails?.meta_data.store?.has_all_access &&
    !channelDetails?.isRootChannel

  return { eventPassAvailable, subscriptionsAvailable }
}
